import { createSSRApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@site/App.vue';
import { createAppRouter } from '@site/router';
import { createI18nInstance } from '@/plugins/createI18n';
import { createMetaManager, META_MANAGER_KEY } from '@/composables/useMeta';
import type { LinkPageHost } from '@/modules/link-page/domain/entities/LinkPage';

export function createApp(url?: string, initialLocale?: string | null, linkPage: LinkPageHost | null = null) {
  const app = createSSRApp(App);
  const pinia = createPinia();
  const router = createAppRouter(import.meta.env.SSR, linkPage);
  const { i18n, locale } = createI18nInstance(initialLocale);
  const metaManager = createMetaManager();

  app.use(pinia);
  app.use(i18n);
  app.use(router);
  app.provide('initial-locale', locale);
  app.provide(META_MANAGER_KEY, metaManager);

  return { app, router, pinia, i18n, locale, metaManager, url };
}
